import { Component, ViewEncapsulation, ViewChild, OnInit } from '@angular/core';
import { DrNamedQuery } from '../../../models/dr-named-query';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import * as _ from 'underscore';
import { BaseModalComponent } from '../../../models/base-modal-component';
import { Endpoint, HelpIndex, NotificationSeverityCode } from '../../../models/enums';
import { CommonService } from '../../../services/common/common.service';
import { RestService } from '../../../services/rest/rest.service';
import { KeyValueListComponent } from '../../key-value-list/key-value-list.component';

@Component({
    standalone: false,
    selector: 'res-notification-modal',
    templateUrl: './notification-modal.component.html',
    styleUrls: ['./notification-modal.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class NotificationModalComponent extends BaseModalComponent implements OnInit {
    @ViewChild(KeyValueListComponent, { static: true }) keyValueList: KeyValueListComponent;

    modalTitle: string;
    modalAutomationId: string;
    modalType: string;
    modalClass = 'notification-modal';
    verifyRequiredValidator = true;
    primaryButtonLabel = 'OK';
    secondaryButtonLabel = 'Cancel';
    modalHelpIndex;
    isBusy = false;
    isBusyMessage = '';
    currentEmail: string;

    successChecked = true;
    failureChecked = true;
    allEmails = [];
    allEmailsToSend: Array<string>;
    events: Array<string>;

    constructor(
        private modalService: BsModalService,
        private modalRef: BsModalRef,
        private restService: RestService,
        private commonService: CommonService) {
        super(modalService, modalRef);
    }

    ngOnInit(): void {
        if (this.modalData) {
            this.currentEmail = this.commonService.currentUser.originalCustomerName === 'super_system_customer'
                || this.commonService.currentUser.type === 'System User' ? this.modalData.currentEmail : this.commonService.currentUser.email;
            this.modalType = this.modalData.modalType;
            switch (this.modalType) {
                case 'job-notification':
                    this.modalTitle = this.modalData.isFromWorkbasket ? 'Task Notification' : 'Job Notification';
                    this.modalHelpIndex = HelpIndex.sys_job_notification_dlg;
                    this.modalAutomationId = 'job-notification';
                    break;
                case 'task-notification':
                    this.modalTitle = 'Task Notification';
                    this.modalHelpIndex = HelpIndex.promotion_tracker_notification_dlg;
                    this.modalAutomationId = 'task-notification';
                    break;
            }
        }
        this.getEmail();
    }

    getEmail(): void {
        const updatedEmail = this.commonService.getCacheData('mail');
        const mailAddress = updatedEmail && this.currentEmail === '' ? updatedEmail : this.currentEmail
        if (mailAddress) {
            this.allEmails.push(new DrNamedQuery({ name: mailAddress }));
        }
        this.allEmails.push(new DrNamedQuery({ name: '' }));
    }

    isPrimaryButtonEnabled(): boolean {
        if (this.allEmails) {
            const emails = [];
            this.allEmails.filter(element => {
                if (element.name !== '') {
                    emails.push(element.name);
                }
            });
            if ((emails.length > 0) && (this.successChecked || this.failureChecked)) {
                return true;
            } else {
                return false;
            }
        }
    }

    ok(): void {
        this.isBusy = false;
        this.events = [];
        if (this.successChecked) {
            this.modalType === 'job-notification' ? this.events.push('COMPLETE') : this.events.push('SUCCESS_WARNING');
        }
        if (this.failureChecked) {
            this.events.push('FAILURE');
        }
        if (this.allEmails) {
            this.allEmailsToSend = [];
            this.allEmails.filter(element => {
                this.allEmailsToSend.push(element.name);
            });
            for (let i = 0; i < this.allEmailsToSend.length; i++) {
                this.allEmailsToSend[i] = this.allEmailsToSend[i].trim();
            }
        }
        if (this.modalData?.item) {
            const targetHandles = this.modalType === 'job-notification' ? this.modalData.item.map(job => job.handle) : [this.modalData.item[0].importJobId];
            const targetType = this.modalType === 'job-notification' ? 'TASK' : 'REVIEW_UPLOAD';
            this.restService.post(Endpoint.realmManager_createAlertConditions, {
                targetHandles: targetHandles, targetType: targetType, events: this.events, severity: NotificationSeverityCode.INFO, recipients: this.allEmailsToSend.filter(email => email.trim() !== ''), notifyMe: false,
                alertInterval: 0, repetitive: false
            }).then(() => {
                this.isBusy = false;
                this.closeModal(true, { 'emails': this.allEmailsToSend });
            }, () => {
                this.isBusy = false;
            });
        }
    }
}
